module.exports = __webpack_public_path__ + "static/media/REDTAG-HOME-Mobo1..f6729755.png";